<template>
    <card
        :label-top-left="$t('msg.notes')"
        :label-bottom-left="$t('txt.note.desc')"
        icon="mdi-note-text-outline"
        class="card_max-xs"
    >
        <template
                slot="header"
        >
            <v-btn
                small
                fab
                color="primary"
                :to="{name: 'create_note'}"
                elevation="0"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>
        <template v-slot:bottom>
            <filters
                    v-model="filters"
                    :bool-singles="['is_archive']"
                    name="notes"
                    @clear="clearFilters"
            >
                <v-autocomplete
                        v-model="filters.tags"
                        :label="$t('msg.markers')"
                        style="max-width: 300px;"
                        :items="tags"
                        chips
                        deletable-chips
                        small-chips
                        clearable
                        multiple
                        outlined
                        dense
                        hide-details
                ></v-autocomplete>
                <v-switch
                        v-model="filters.is_archive"
                        :label="$t('msg.isArchive')"
                        dense
                        hide-details
                ></v-switch>
            </filters>
        </template>
        <v-data-table
                :headers="headers"
                :items="filteredModels"
                :loading="loading"
                sort-by="name"
                :mobile-breakpoint="0"
                :class="{'v-data-table_mobile': $vuetify.breakpoint.xsOnly}"
        >
            <template v-slot:item.name="{item}">
                <div
                        @click="$router.push({name: 'note', params: {'id': item.id}})"
                >
                    <router-link
                            :to="{name: 'note', params: {'id': item.id}}"
                            style="color: #333"
                    >{{ item.name }}</router-link>
                    <div v-if="$vuetify.breakpoint.xsOnly">
                        <tags v-model="item.tag"></tags>
                    </div>
                </div>
            </template>
            <template v-slot:item.tag="{item}">
                <tags v-model="item.tag"></tags>
            </template>
        </v-data-table>
    </card>
</template>

<script>
    import Filters from '@/components/ui/Filters';
    import Tag from "../../components/ui/Tag";
    import Tags from "../../components/ui/Tags";

    export default {
        components: {Tags, Filters, Tag},
        data() {
            return {
                loading: false,
                models: [],
                tags: [],
                searchTags: [],
                filters: {
                    tags: [],
                    is_archive: false
                }
            }
        },
        computed: {
            filteredModels() {
                return this.models.filter(model => {

                    let tags = () => {
                        if (this.filters.tags.length === 0) return true;
                        for (let key in model.tag) {
                            if (this.filters.tags.includes(model.tag[key])) {
                                return true
                            }
                        }
                        return false;
                    };

                    let isArchive = () => {
                        return model.is_archive === this.filters.is_archive;
                    };

                    return tags() && isArchive();
                });
            },
            headers() {
                let items = [
                    {text: this.$t('msg.name'), value: 'name', align: 'left', sortable: true, show: true},
                    {text: this.$t('msg.markers'), value: 'tag', align: 'left', sortable: true, show: !this.$vuetify.breakpoint.xsOnly}
                ];

                return items.filter(v => v.show);
            }
        },
        methods: {
            clearFilters() {
                this.filters.tags = [];
                this.filters.is_archive = false;
            },
            loadModels() {
                this.loading = true;
                this.$store.dispatch('loadNotes')
                    .then(res => {
                        this.models = res;
                        this.collectTags();
                    })
                    .finally(() => this.loading = false);
            },
            collectTags() {
                this.tags = [];
                this.models.forEach(model => {
                    model.tag.forEach(tag => {
                        if (!this.tags.includes(tag)) {
                            this.tags.push(tag);
                        }
                    });
                })
            }
        },
        created() {
            this.loadModels();
        }
    }
</script>